const WEB_ORIGIN = 'https://peakperformanceiq.com';

export function circleInviteUrl(inviteCode: string): string {
  const code = inviteCode.trim().toUpperCase();
  const origin = typeof window !== 'undefined' ? window.location.origin : WEB_ORIGIN;
  return `${origin}/circles/join/${encodeURIComponent(code)}`;
}

export async function shareCircleInvite(circleName: string, inviteCode: string): Promise<'shared' | 'copied'> {
  const url = circleInviteUrl(inviteCode);
  const text = `Join my Circle "${circleName}" on Peak Performance IQ — we compete on sticking to our plans, not who lifts the most.`;

  if (typeof navigator !== 'undefined' && navigator.share) {
    try {
      await navigator.share({ title: `Join ${circleName}`, text, url });
      return 'shared';
    } catch {
      /* fall through to copy */
    }
  }

  const payload = `${text}\n${url}`;
  if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(payload);
  }
  return 'copied';
}
